import { Component } from '@angular/core'
import { MbCaasService } from '../../cms/services/mb-caas/mb-caas.service'
import { MbConstants } from '../../shared/mb-constants'
import { CaasIdType } from '../../cms/enums/caas-id-types'
import { map } from 'rxjs/operators'
import { ContactBoxMyAccountContactData } from '../my-account.module'

const keys = [
  { key: 'page.children.children.name', operator: 1 },
  { key: 'locale.country', operator: 1 },
  { key: 'page.children.children.formData', operator: 1 }
]

@Component({
  selector: 'mb-myaccount-contactbox',
  templateUrl: './mb-myaccount-contactbox.component.html',
  styleUrls: ['./mb-myaccount-contactbox.component.scss']
})
export class MbMyaccountContactboxComponent {

  contactData$ = this.caasService.getByIds([MbConstants.CONTACT_BOX_IN_MY_ACCOUNT], CaasIdType.SEOURL, keys).pipe(
    map(res => this.mapContactBoxData(res?.[0] ?? {}))
  )

  constructor (protected caasService: MbCaasService) {
  }

  private mapContactBoxData (data: any): ContactBoxMyAccountContactData {
    const componentData = data.page?.children?.[1]?.children?.[0] ?? {}
    const contactData = componentData.formData?.['st_contact']?.value?.[0]?.formData ?? {}
    return {
      ordersEmail: contactData.gc_orders_email?.value ?? '',
      ordersPhone: contactData.gc_orders_phone?.value ?? '',
    }
  }
}
